import PageNotFound from 'component/page/PageNotFound';

export { PageNotFound }

export default Object.assign({
    PageNotFound
})